var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Handsfree",class:{ disable : _vm.disable }},[_c('div',{staticClass:"Handsfree__hand "},[_vm._v(_vm._s(_vm.lft_locked))]),_c('div',{staticClass:"Handsfree__hand right"},[_vm._v(_vm._s(_vm.rgt_locked))])])}
var staticRenderFns = []

export { render, staticRenderFns }